module.exports = __webpack_public_path__ + "static/media/x250d-2.e0ec501b.jpg";